module.exports = __webpack_public_path__ + "img/9788934941651.ca02c35b.jpg";